import api from "./api.js";

export default class PaymentApi {
  static async Create(data) {
    return await api.post(`web/payment`, data);
  }
}
